const AUTOMATED_REVIEWERS = [
  {
    slug: 'github-advanced-security',
    displayName: 'GitHub Advanced Security',
    hovercard: 'ghas',
  },
  {
    slug: 'github-code-quality',
    displayName: 'GitHub Code Quality',
    hovercard: 'code-quality',
  },
] as const

export type AutomatedReviewer = (typeof AUTOMATED_REVIEWERS)[number]

const AUTOMATED_REVIEWERS_BY_SLUG = new Map<string, AutomatedReviewer>(
  AUTOMATED_REVIEWERS.map(reviewer => [reviewer.slug, reviewer]),
)

export function getAutomatedReviewer(slug: string | undefined): AutomatedReviewer | undefined {
  return slug ? AUTOMATED_REVIEWERS_BY_SLUG.get(slug) : undefined
}
